var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg146Download(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,285c11.046,0,20-8.954,20-20V20c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20v245 C236,276.046,244.954,285,256,285z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.472,367.324c0.034,0.034,0.067,0.068,0.101,0.102c11.701,11.701,27.069,17.549,42.437,17.549 c15.356,0,30.71-5.842,42.388-17.521L408.114,257.17c7.826-7.795,7.851-20.458,0.056-28.284 c-7.795-7.825-20.458-7.851-28.284-0.056L269.142,339.142c-3.778,3.777-8.8,5.858-14.142,5.858 c-5.323,0-10.329-2.065-14.102-5.817L132.243,228.959c-7.754-7.867-20.418-7.957-28.284-0.203 c-7.866,7.754-7.957,20.417-0.203,28.284L212.472,367.324z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,412c-11.046,0-20,8.954-20,20c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40c0-11.046-8.954-20-20-20 s-20,8.954-20,20c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80C512,420.954,503.046,412,492,412z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg146Download);
export default __webpack_public_path__ + "static/media/146-download.0b92945be2c176307897538e4baa271e.svg";
export { ForwardRef as ReactComponent };